/* eslint-disable max-len */
/* eslint-disable max-lines */
/* eslint-disable max-statements */
/* eslint-disable complexity */
import {useEffect, memo, useRef, forwardRef, useMemo, useCallback, useState, Profiler} from 'react';
import {useHistory} from 'react-router-dom';
import {useIntl} from 'react-intl';
import assert from 'assert';
import classNames from 'classnames';

import sdk from '@/sdk';
import RealtimeEditor, {EditorModeType, EditorState, EditorOptions, CommonOptions, getRTEBackUpUrl, getRTEWebsocketUrl} from '@/rte';
import {useImageConfig} from '@/rte/image';
import {useHyperLinkConfig} from '@/rte/hyperLink';
import {useTransclusionConfig} from '@/rte/transclusion';
import {useSlideConfig} from '@/rte/slide';
import {useCoverConfig} from '@/rte/cover';
import {useMaterialConfig} from '@/rte/material';
import * as store from '@/store';
import {isSafari} from '@/config/env';
import {docEditAble, isCurDocPageAdmin} from '@/store/util';
import {Props, IRteToken, DocumentOperateType, IAiChatPanel} from '@/interface';
import {
    DEFAULT_APP_ID,
    EDITOR_TEXT_MIN_WIDTH,
    EDITOR_MODE,
    RepositorySourceType,
    PageSecurityIsSelected,
    EDITOR_TEXT_MIN_WIDTH_CONTENT_ONLY,
} from '@/Constant';
import {DEMO_MODE_TYPE, WEB_OFFICE_URL} from '@/constants/document/doc';
import {HistoryModeTabValue} from '@/constants/common';
import {INotify} from '@/types/document/notification';
import {useOnlineTodoConfig, useTodoConfig} from '@/rte/todo/config';
import {useGetVersionUrl} from '@/hooks/document/useGetVersionUrl';
import toast, {ToastType} from '@/components/Toast';
import {TemplateArea} from '@/domains/document/DocHome/common/TemplateArea';
import DocErrorBoundary from '@/DocErrorBoundary';
import {concatImgSrc} from '@/utils/avatarUtils';
import {ServerConfig, routerPublicPath} from '@/config/routers';
import {reportCopyVersionLinkClick} from '@/buried/historyVersion';
import type {HistoryInterface} from '@/types/document/doc';
import {
    feLogger,
    createDataSheetBlockReport,
    openPageUrl,
    selectionWordCount,
} from '@/buried';
import {openPanel} from '@/plugins/AIChatPlugin/AigcChat/utils/panelStatus';
import {SideTabKey, WizRequestOptions} from '@/interface';
import {createDocEdition} from '@/sdk/edition';
import kuJSSDKEventBus, {NEW_DOC_VERSION} from '@/eventBus/kuJSSDK/bus';

// import {IHighlightContent} from '@/domains/document/DocHome/Document/entityLinking';
import {useMentionOptions} from '@/hooks/mention';
import {useDataSheetConfig, useSubDocListConfig} from '@/hooks/document/useEditorProps';
import {useLinkTransformConfig} from '@/rte/linkTransform';
import {useOCRInit} from '@/plugins/AIChatPlugin/AigcChat/hooks/useOCR';
import EditorBanner from './EditorBanner';
import EditorChildren from './EditorChildren';

import styles from './index.module.scss';
import {rteNotifyDomAction, rteNotifyInitAction, rteNotifyType} from '@/constants/document/notification';
import {fetchDocToken} from '@/services';
import eventBus, {CLICK_ADD_MATERIAL} from '@/eventBus';

import kuPiper from '@/middleware/kuPiper';
import {LOG_DOC_TYPE} from '@/buried/performance/const';
import useDemoMode from '@/hooks/document/useDemoMode';
import {useCommentLocationOptions, useCommentShareAndCopy} from '@/hooks/comment';
import {useCommentFollow} from '@/hooks/document/useCommentFollow';
import {
    useRenderEmbedInlineWrapper,
    useRender2EmbedContainerWrapper,
} from '@/utils/document/flow';

import {
    useCommentCreateChat,
} from '../../common/CommentCreateChat';
import {
    usePdf2Word,
} from '../../common/pdfConvertWord/pdf2WordNew';
import {EntityEventInfo} from '@/rte/highlight/config';
import {useAigcConfig} from '@/rte/aigc';
import {getMorphoService, serviceNames} from '@/rte/editor';
import {shareToRuLiu} from '@/components/Share';
import {useStatisticsOptions} from '@/hooks/statistics';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';
import {useCheckDocEmpty} from '@/domains/document/hooks/useCheckDocEmpty';
import {perfLogger, PROFILER_KEY} from '@/buried/performance';
import {IMode, updateKuStatusMode} from '@/utils/document/kuNotifyStatus';
import {useReturnTop} from '../../common/ReturnTop';
import {useCardViewUpdate} from '../../common/CardViewUpdate';
import {getDocMaxWidth, getDiagramLoadAll, getMindMapLoadAll, transformHyperlink} from '@/utils/document/common';
import {CardLike} from '@/domains/document/DocHome/common/CardLike';
import Template from '../../common/Template';
import useTemplateList, {DocType} from '../../common/Template/useTemplateList';
import {useShowTemplate} from '@/domains/document/hooks/useShowTemplate';
import {useMorphoPlugin} from '@/kuTools/plugins/useMorphoPlugin';
import {useCommentNoticeInfo} from '../../common/CommentNoticeInfo';
import {loadExtension} from '@/kuTools/utils';
import {VIEW_BLOCK} from '@/hooks/queryViewController/config';
import {isShowCurrentView} from '@/hooks/queryViewController';
// import {useEditorSmallFlows} from '@/rte/smallFlow';


RealtimeEditor.displayName = 'RealtimeEditor';

// async function uploadImg(...args: any) {
//     const result = await uploadImage(args[0], args[1]);
//     console.log(result);
//     return result;
// }

const rteServer = ServerConfig.rte;

export type EmbedTypes = 'embed' | 'baiduMap' | 'codePen' | 'aigc' | 'score' | 'dataSheet' | 'datasheetDoc';

export enum MODE {
    preview = 'preview',
    edit = 'editor',
    history = 'history',
    meeting = 'meeting',
}

export interface EditorChangeData {
    lastModify: number;
    isEmpty: boolean;
    title: string;
}
interface IHighlightConfig {
    onDomReady?: () => void;
    enable?: boolean;
    onHCUpdate?: () => void;
    getEntityList?: (data: {entityList: EntityEventInfo}) => void;
    usePopperEffect?: (par: EntityEventInfo[]) => void;
    onFeedbackClick?: (par: EntityEventInfo[]) => void;
    onFeedbackSubmit?: (par: EntityEventInfo[]) => void;
    onLikedChange?: (par: EntityEventInfo[]) => void;
    onBlockEntity?: (par: EntityEventInfo[]) => void;
    openPageOfBaike?: (par: EntityEventInfo[]) => void;
    onRelatedPersonClick?: (par: EntityEventInfo[]) => void;
    onLinkClick?: (par: EntityEventInfo[], url: string) => void;
    onPoweredByClick?: (par: EntityEventInfo[]) => void;
    onExpandPolyseme?: (par: EntityEventInfo[]) => void;
    onLinkPolyseme?: (par: EntityEventInfo[]) => void;
}

const {
    useIsInGray: useIsCardViewSP3Gray,
} = initGray(GRAY_RELEASE_KEYS.cardViewSP3);

const {
    useIsInGray: useIsCardViewMarkKeyPointGray,
} = initGray(GRAY_RELEASE_KEYS.cardViewMarkKeyPoint);

const {
    useIsInGray: useNavCardHead,
} = initGray(GRAY_RELEASE_KEYS.navCardHead);

const {
    useIsInGray: useShowTableSelectionMenu,
} = initGray(GRAY_RELEASE_KEYS.showTableSelectionMenu);

const {
    useIsInGray: useIsDocCatalogCard,
} = initGray(GRAY_RELEASE_KEYS.docCatalogCard);

const {
    useIsInGray: useIsRightCommentFollow,
} = initGray(GRAY_RELEASE_KEYS.rightCommentFollow);

const {
    useIsInGray: useIsFlowChartInGray,
} = initGray(GRAY_RELEASE_KEYS.flowChartInGray);

const {
    useIsInGray: useIsHorizontalDrag,
} = initGray(GRAY_RELEASE_KEYS.horizontalDrag);

export interface DocumentPageEditorProps extends Props {
    repository: Repository;
    docGuid: string;
    mode: EDITOR_MODE;
    demoMode: boolean;
    isCardView: boolean;
    showSlide: boolean;
    isNew: boolean;
    showIframeMask: boolean;
    onChangeMode: (mode: EDITOR_MODE) => void;
    onTemplateClick: () => void;
    isWideScreenMode?: boolean | undefined;
    hasEditPermission: boolean;
    onRteNotify: (data: INotify) => void;
    handleChange: () => void;
    highlightConfig: IHighlightConfig;
    updateDoTitle: (title?: string) => void;
    pageSecuritySettings: any;
    docForbidCopy: boolean;
    docForbidPrint: boolean;
    curDocTokenData?: IRteToken;
    curDocument: WizDocument;
    isKuShareMode?: string;
    isOpenAigc?: boolean;
    openAigcInfo?: any;
    kuShareParams?: any;
    isAiChatOpen?: boolean;
    quickCmdEnable?: boolean;
    titleNode?: any;
    docTitle?: string;
    isDocEmptyWithSpace?: boolean;
}

export interface StorageModeType {
    docGuid: string;
    type: string;
}

const aigcUrl = process.env.REACT_APP_AIGC_URL;

const Editor = memo(forwardRef((props: DocumentPageEditorProps, ref: any) => {
    const intl = useIntl();
    const {
        repository,
        docGuid,
        showIframeMask,
        isNew,
        mode,
        demoMode,
        isCardView,
        showSlide,
        isWideScreenMode,
        hasEditPermission = false,
        onChangeMode,
        onTemplateClick,
        onRteNotify,
        handleChange,
        highlightConfig,
        updateDoTitle,
        pageSecuritySettings,
        docForbidCopy,
        docForbidPrint,
        curDocTokenData,
        curDocument,
        isKuShareMode,
        openAigcInfo,
        isOpenAigc,
        kuShareParams,
        isAiChatOpen,
        quickCmdEnable = false,
        titleNode = {},
        docTitle,
        // showTemplate,
        isDocEmptyWithSpace,
    } = props;
    const userGuid = sdk.as.user?.userGuid;
    const history = useHistory<HistoryInterface>();
    const rwMode = store.getRwMode();
    const {accessToken, docGuid: docGuidFromTokenData} = curDocTokenData || {};
    const dataSheetConfig = useDataSheetConfig();
    const subDocListConfig = useSubDocListConfig({enableInsert: true});
    const linkTransformOptions = useLinkTransformConfig({docGuid});
    const morphoPlugins = useMorphoPlugin(repository.repositoryGuid);
    const isCardViewSP3Gray = useIsCardViewSP3Gray();
    const isCardViewMarkKeyPointGray = useIsCardViewMarkKeyPointGray();
    const isDocCatalogCard = useIsDocCatalogCard();
    const isNavCardHead = useNavCardHead();
    const isShowTableSelectionMenu = useShowTableSelectionMenu();
    const isRightCommentFollow = useIsRightCommentFollow();
    const isHorizontalDragGray = useIsHorizontalDrag();
    const isFlowChartInGray = useIsFlowChartInGray();

    const isExternalRepo = repository?.external;

    // 划线评论创建群聊相关
    const [CommentCreateChatModal, commentChatOptions] = useCommentCreateChat(docGuid);
    // 评论通知提前漏出
    const [CommentNoticeInfo] = useCommentNoticeInfo(docGuid, repository.repositoryGuid, !!isKuShareMode);

    // pdf转换word
    const {convertPDF2Word: convertPDF2WordFn} = usePdf2Word(docGuid, userGuid);

    // 同步空文档状态
    const {syncIsDocEmptyDebounce, setIsDocEmpty} = useCheckDocEmpty(docGuid, mode);

    // 全文模版数据
    const {curTpls, status: templateRequestDone} = useTemplateList({isCardView, mode, docGuid});
    const {
        showTemplate,
        isAllowShowTemplate,
        showDefaultTemplate,
        setShowTemplate,
        setIsAllowShowTemplate,
    } = useShowTemplate({
        isDocEmptyWithSpace: !!isDocEmptyWithSpace,
        docGuid,
        mode,
        haveTemplate: Boolean(curTpls?.sysTpls?.length + curTpls?.userTpls?.length),
    });

    // pdf转换word  仅支持预览态（编辑权限）+编辑态+协作模式 + 小流量
    const showConvertWordEntry =
        (mode === EDITOR_MODE.preview || mode === EDITOR_MODE.edit || mode === EDITOR_MODE.meeting)
        && !demoMode
        && hasEditPermission;

    const showEditorOutline = isShowCurrentView(VIEW_BLOCK.editorOutLine);
    const showUnderlineComment = isShowCurrentView(VIEW_BLOCK.editorUnderlineComment);
    const showNormalWidth = isShowCurrentView(VIEW_BLOCK.editorShowNormalWidth);

    // hasEditPermission异步。为了不阻塞页面加载，在hasEditPermission返回后再进行参数更新
    useEffect(() => {
        try {
            const config = getMorphoService(serviceNames.IConfigService);
            if (config) {
                // pdf转word
                const preValue = config.state.attachmentConfig.getValue();
                if (showConvertWordEntry && !preValue.convertPDF2Word) {
                    config.state.attachmentConfig.next({
                        ...preValue,
                        convertPDF2Word: window.isTocPage ? undefined : convertPDF2WordFn,
                    });
                } else if (!showConvertWordEntry && preValue.convertPDF2Word) {
                    config.state.attachmentConfig.next({
                        ...preValue,
                        convertPDF2Word: undefined,
                    });
                }
            }
        } catch (err) {
            console.error(err);
        }
    }, [convertPDF2WordFn, showConvertWordEntry]);

    useEffect(() => {
        perfLogger.bindGetEditorVersion((changeMode?: boolean) => {
            return ref && ref.current ? ref.current.getVersionInfo(changeMode) : null;
        });
        return () => {
            perfLogger.bindGetEditorVersion(null);
        };
    }, [ref]);
    useEffect(() => {
        perfLogger.editorPaint.paintStart('load', mode as any, LOG_DOC_TYPE.doc);
        return () => {
            perfLogger.editorPaint.paintStop();
            store.setStatNumShow(false); // 切换文档时，隐藏顶栏统计数据
        };
        // 需要在文档切换时上报load 故需要绕过检查
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [docGuid]);

    // 处理模式切换时，顶栏统计数据相关逻辑
    useEffect(() => {
        let timer: NodeJS.Timeout | null = null;
        if (mode === EDITOR_MODE.preview) {
            // 防止出错，预览态若十秒后还未收到划线评论数据通知，则默认显示顶栏数据统计
            timer = setTimeout(() => {
                const isStatNumShow = store.getData(store.KEYS.IS_STAT_NUM_SHOW);
                if (!isStatNumShow) {
                    store.setStatNumShow(true);
                }
            }, 10000);
        }
        return () => {
            timer && clearTimeout(timer);
        };
    }, [mode]);

    useEffect(() => {
        if ([EDITOR_MODE.edit, EDITOR_MODE.meeting].includes(mode)) {
            perfLogger.editorInputDelay.bind();
        } else {
            perfLogger.editorInputDelay.unbind();
        }
        return () => {
            perfLogger.rteOpLossRatio.logWeb();
            perfLogger.editorInputDelay.unbind();
        };
    }, [mode]);

    useEffect(() => {
        function prevent(e: Event) {
            e.preventDefault();
        }
        document.addEventListener('drop', prevent, false);
        document.addEventListener('dragover', prevent, false);

        return () => {
            document.removeEventListener('drop', prevent);
            document.removeEventListener('dragover', prevent);
        };
    }, []);

    const updateRteToken = useCallback(async () => {
        try {
            await fetchDocToken(repository, docGuid);
        } catch (err) {
            console.error('err: ', err);
        }
    }, [docGuid, repository]);

    const handleTplClick = useCallback(async (template: Template, onCloseModal: () => void) => {
        try {
            assert(repository);
            const ksServer = await sdk.getKsServer(repository);
            await ksServer.updateDocument(docGuid, {
                action: DocumentOperateType.Template,
                rteId: template.rteId,
            });
            store.setIsCardView(template.docType === DocType.card);
            // 同步模板内容后，更新文档为空的状态信息
            setIsDocEmpty(false);
            // 重置弹窗的展开状态
            onCloseModal();
            onTemplateClick && onTemplateClick();
        } catch {
            toast({
                type: ToastType.Error,
                content: intl.formatMessage({id: 'toastPublishError'}),
            });
        }
    }, [docGuid, intl, onTemplateClick, repository, setIsDocEmpty]);

    // 全文评论中链接点击事件
    // 全文评论接入编辑器后，不需要再另外处理点击事件了，后面可以删去
    // @小马哥 删的时候记得把相关proxy一起删掉呀
    const handleCommentUrlClick = kuPiper.runProxy(kuPiper.proxyNameMap.pageCommentUrlClickJump);

    const focusToTitle = useCallback(() => {
        const titleDiv = document.getElementById('documentTitleDiv');
        if (titleDiv) {
            const selection = window.getSelection();
            const range = document.createRange();
            range.setStart(titleDiv, 0);
            range.setEnd(titleDiv, 0);
            if (selection) {
                selection.removeAllRanges();
                selection.addRange(range);
                selection.selectAllChildren(titleDiv);
                selection.collapseToEnd();
            }
        }
    }, []);

    const isPreviewMode = mode === EDITOR_MODE.preview;
    const isEditMode = mode === EDITOR_MODE.edit;
    const isHistoryMode = mode === EDITOR_MODE.history;
    const showFullScreen = mode === EDITOR_MODE.history || demoMode;
    const editorMode: EditorModeType = (() => {
        if (mode === EDITOR_MODE.normal) {
            return MODE.edit;
        }
        if (mode === EDITOR_MODE.edit) {
            return MODE.edit;
        }
        if (mode === EDITOR_MODE.meeting) {
            return MODE.meeting;
        }
        if (mode === EDITOR_MODE.history) {
            return MODE.history;
        }
        return MODE.preview;
    })();

    interface screenModeProps {
        maxWidth?: number | 'none';
        minWidth: number;
    }
    const screenMode: screenModeProps = {
        maxWidth: getDocMaxWidth(!!isWideScreenMode, isCardView, !!isKuShareMode),
        minWidth: showNormalWidth ? EDITOR_TEXT_MIN_WIDTH : EDITOR_TEXT_MIN_WIDTH_CONTENT_ONLY,
    };

    const {nickname, department, email} = sdk.as.user;

    const mentionOptions = useMentionOptions(ref, mode, true);
    const commentOptions = useCommentLocationOptions();
    const {commentDefaultChecked, onMentionSwitchValueChange} = useCommentFollow({
        docGuid,
        curDocument,
        curRepository: repository,
    });
    const commentShareAndCopy = useCommentShareAndCopy();
    // 如果是部门公告专用知识库，隐藏阅读统计插件
    const showReadStatistics = repository?.sourceType !== RepositorySourceType.notice;
    const statisticsOptions = useStatisticsOptions({
        show: showReadStatistics,
    });

    // 协作模式下，只读权限要显示编辑者列表入口
    const showCardAuthors = isPreviewMode ||
        (editorMode === EDITOR_MODE.meeting && !docEditAble(repository, curDocument));

    // 需求：成员/管理员，页面管理员/编辑 以外不可复制
    const handleRteNotify = useCallback(
        res => {
            if (res.type === rteNotifyType.TOKEN) {
                updateRteToken();
            }
            if (res.type === rteNotifyType.INIT && res.action === rteNotifyInitAction.PAGE_START) {
                const logConst = perfLogger.loadTimeDetailed.const;
                perfLogger.loadTimeDetailed.save(logConst.EDITOR_MOUNT_TIME, res.data.timestamp);
            }
            if (res.type === rteNotifyType.INIT && res.action === rteNotifyInitAction.END) {
                loadExtension();
                const showCard = isShowCurrentView(VIEW_BLOCK.editorCardMode);
                if (!showCard) {
                    const editorRef = store.getEditorRef();
                    const instance = editorRef.current?.getEditorInstance();
                    instance?.__cardService.setShowCard(false);
                    instance?.__cardService.setCardProps({
                        slide: false,
                    });
                }
            }
            /**
             * 文档组件在编辑器切换到【查看历史版本】后重新加载
             * TODO: 历史版本模式下不会收到 type: rteNotifyType.INIT 和 action: rteNotifyInitAction.END 的消息，目前暂时通过监听 domReady 事件处理渲染
             * 但历史版本模式下 domReady 目前会触发 4 次，目前这样处理暂时没问题，后续有问题再具体看
             */
            if (
                mode === EDITOR_MODE.history
                && res.type === rteNotifyType.DOM
                && res.action === rteNotifyDomAction.DOM_READY
            ) {
                loadExtension();
            }
            onRteNotify && onRteNotify(res);
        },
        [onRteNotify, updateRteToken, mode]
    );

    const validateDownload = useCallback(() => {
        // 只读成员禁止下载附件
        const isDisableReader = pageSecuritySettings && PageSecurityIsSelected.includes(
            pageSecuritySettings.downloadStatus
        );
        const editable = curDocument && docEditAble(repository, curDocument);

        return editable || !isDisableReader;
    }, [curDocument, pageSecuritySettings, repository]);

    const {
        renderLayoutNode: renderDemoModeLayoutNode,
        demoModeType,
        rootRef,
        contentContainerRef,
        zoom,
        pageNum,
        onPageChange,
        onPageTotalChanged,
        nextPaging,
        handleEsc,
        handleChangeType,
    } = useDemoMode({
        demoMode,
        docGuid,
        closeDemoMode: () => store.setDemoMode(false),
        isCardView,
        isNew: true, // 是否是引入卡片视图后的新版演示模式，小流量逻辑 (知识库-卡片视图)
    });
    const slideConfig = useSlideConfig({
        docGuid,
        showSlide,
        hasEditPermission,
    });
    const enableCardBlockRef = slideConfig.enableCardBlockRef;
    const disableCardCopyAndShare = isHistoryMode;

    const coverConfig = useCoverConfig(docGuid);

    const materialConfig = useMaterialConfig({
        docGuid,
        docForbidCopy,
        enable: !isKuShareMode && mode !== EDITOR_MODE.history,
    });

    const renderCardLike = useCallback((blockId: string, index: number) => {
        return <CardLike blockId={blockId} index={index} />;
    }, []);

    const onDragInsert = useCallback(async (res: any) => {
        try {
            const ksServer = await sdk.getKsServer();
            ksServer.matterApply({
                docGuid: res.docGuid,
                matterGuid: res.matterGuid,
            });
        } catch (error) {
            console.error(error);
        }
    }, []);

    useEffect(() => {
        try {
            const config = getMorphoService(serviceNames.IConfigService);
            if (config && !window.isTocPage) {
                const preValue = config.state.slide.getValue();
                const isSdkPageAndNoSlide = (window as any).isSdkPage && !preValue;
                if (!isSdkPageAndNoSlide) {
                    config.state.slide.next({
                        ...preValue,
                        enableAISlideMenu: !!isCardViewSP3Gray,
                        enableAIMarkKeyPoint: !!isCardViewMarkKeyPointGray,
                        enableCardBlockRef,
                        disableCardCopyAndShare,
                        getCardMenu: window.isTocPage ? undefined : (mode === EDITOR_MODE.preview ? renderCardLike : undefined),
                        showCardAuthors: window.isTocPage ? false : showCardAuthors,
                    });
                }

            }
        } catch (err) {
            console.error(err);
        }
    }, [
        isCardView,
        mode,
        isCardViewSP3Gray,
        isCardViewMarkKeyPointGray,
        userGuid,
        enableCardBlockRef,
        disableCardCopyAndShare,
        renderCardLike,
        showCardAuthors,
    ]);


    useEffect(() => {

        try {
            const config = getMorphoService(serviceNames.IConfigService);
            if (config) {
                const preValue = config.state.slide.getValue();
                const materialPreValue = config.state.material.getValue();
                config.state.slide.next({
                    ...preValue,
                    enableQuickInsert: !!templateRequestDone, // 默认=优化空行的输入引导&空白卡片推荐'分栏和模板
                });
                config.state.material.next({
                    ...materialPreValue,
                    usePlaceholder: true, // 插入模板库使用预置文案
                    onDragInsert: (res: any) => {onDragInsert(res);},
                });
            }
        } catch (err) {
            console.error(err);
        }
    }, [
        templateRequestDone,
        onDragInsert,
    ]);


    useEffect(() => {
        try {
            // toc对外知识库外部视角场景没有模板库
            if (window.isTocPage) {
                return;
            }
            const config = getMorphoService(serviceNames.IConfigService);
            if (config) {
                const preValue = config.state.material.getValue();
                const enableMaterial = materialConfig.enable;
                if (enableMaterial && !preValue.enable) {
                    config.state.material.next({
                        ...preValue,
                        enable: true,
                    });
                }
            }
        } catch (err) {
            console.error(err);
        }
    }, [materialConfig.enable]);

    useEffect(() => {
        try {
            const config = getMorphoService(serviceNames.IConfigService);
            if (config) {
                const preValue = config.state.editorConfig.getValue();
                if (isShowTableSelectionMenu && !preValue.showTableSelectionMenu) {
                    config.state.editorConfig.next({
                        ...preValue,
                        showTableSelectionMenu: true,
                    });
                }
            }
        } catch (err) {
            console.error(err);
        }
    }, [isShowTableSelectionMenu]);

    useEffect(() => {
        try {
            const config = getMorphoService(serviceNames.IConfigService);
            if (config) {
                const preValue = config.state.tableOfContents.getValue();
                if (isDocCatalogCard && !preValue.showInserts) {
                    config.state.tableOfContents.next({
                        ...preValue,
                        showInserts: true,
                    });
                }
            }
        } catch (error) {
            console.error(error);
        }
    }, [isDocCatalogCard]);

    // 迁移到小流量自动化，稳定后删掉
    // useEffect(() => {
    //     try {
    //         const config = getMorphoService(serviceNames.IConfigService);
    //         if (config) {
    //             const preValue = config.state.editorConfig.getValue();
    //             if (isNavCardHead && !preValue.enableCardHeadingNav) {
    //                 config.state.editorConfig.next({
    //                     ...preValue,
    //                     enableCardHeadingNav: true,
    //                 });
    //             }
    //         }
    //     } catch (err) {
    //         console.error(err);
    //     }
    // }, [isNavCardHead]);

    useEffect(() => {
        try {
            const config = getMorphoService(serviceNames.IConfigService);
            if (config) {
                const preValue = config.state.commentConfig.getValue();
                if (showUnderlineComment) {
                    config.state.commentConfig.next({
                        ...preValue,
                        defaultCommentFollowState: commentDefaultChecked,
                    });
                }
            }
        } catch (err) {
            console.error(err);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [commentDefaultChecked]);

    useEffect(() => {
        try {
            const config = getMorphoService(serviceNames.IConfigService);
            if (config) {
                const preValue = config.state.mindmapConfig.getValue();
                if (isFlowChartInGray && !preValue.canDoubleClickToEdit) {
                    config.state.mindmapConfig.next({
                        ...preValue,
                        canDoubleClickToEdit: true,
                    });
                }
            }
        } catch (err) {
            console.error(err);
        }
    }, [isFlowChartInGray]);

    useEffect(() => {
        try {
            const config = getMorphoService(serviceNames.IConfigService);
            if (config) {
                const preValue = config.state.diagramConfig.getValue();
                if (isFlowChartInGray && !preValue.canDoubleClickToEdit) {
                    config.state.diagramConfig.next({
                        ...preValue,
                        canDoubleClickToEdit: true,
                    });
                }
            }
        } catch (err) {
            console.error(err);
        }
    }, [isFlowChartInGray]);

    // 一键回顶
    const {ReturnTopNode, isShowReturnTop} = useReturnTop(mode, demoMode, demoModeType);

    const {renderUpdateList} = useCardViewUpdate();

    const handleRteNotifyProxy = kuPiper.runProxy(kuPiper.proxyNameMap.onRteNotifyProxy, handleRteNotify);

    const getVersionUrl = useGetVersionUrl(repository, docGuid);
    const getEditorOptionsProxy = kuPiper.runProxy(kuPiper.proxyNameMap.editorOptionsProxy, () => {
        const editorOptions: EditorOptions = {
            editorConfig: {
                readOnly: !hasEditPermission,
                autoFocus: isNew, // 新建文档进入编辑自动聚焦
                autoFocusPosition: 'start',
                screenMode,
                // 演示模式配置
                mode: {
                    type: demoMode
                        ? 'presentation'
                        : 'normal',
                    presentationOption: {
                        viewMode: demoModeType,
                        container: contentContainerRef.current!,
                        getScrollContainer: () => contentContainerRef.current!,
                        styleBox: contentContainerRef.current!,
                        // zoom: zoom,
                        // pageModeOption: {
                        //     current: pageNum,
                        //     onPageChange,
                        //     onPageTotalChanged,
                        // },
                        onExit: handleEsc,
                        onChangeViewMode: handleChangeType,
                    },
                },
                slideInfo:
                    mode === EDITOR_MODE.history
                        ? undefined
                        : {
                            showSlide: slideConfig.showSlide,
                        },
                onChange: () => {
                    handleChange();
                    syncIsDocEmptyDebounce();
                },
            },
            navigationConfig: showEditorOutline ? {} : false,
            // 是否展示划线评论
            commentConfig: !demoMode && showUnderlineComment,
            historyConfig: {
                getVersionUrl(...args) {
                    reportCopyVersionLinkClick();
                    return getVersionUrl(...args);
                },
            },
        };

        return editorOptions;
    });

    const getScrollContainer = () => {
        if (demoMode) {
            if (demoModeType === DEMO_MODE_TYPE.flow) {
                return rootRef.current;
            }
            if (demoModeType === DEMO_MODE_TYPE.page) {
                return contentContainerRef.current;
            }
        }
        return document.querySelector('.mp-layout-content-container');
    };
    const getScrollContainerRef = useRef<(() => Element | null)>(getScrollContainer);
    getScrollContainerRef.current = getScrollContainer;

    // flowSDK OCR
    const ocrReady = useOCRInit(demoMode);
    const imageConfig = useImageConfig(demoMode, ocrReady);

    const hyperLinkConfig = useHyperLinkConfig(
        docGuid,
        mode === EDITOR_MODE.history || (demoMode && demoModeType === DEMO_MODE_TYPE.page)
    );

    const renderTemplate = useCallback(() => {

        return <Template
            curTpls={curTpls}
            isAllowShowTemplate={isAllowShowTemplate}
            showDefaultTemplate={showDefaultTemplate}
            setShowTemplate={setShowTemplate}
            setIsAllowShowTemplate={setIsAllowShowTemplate}
            onClick={handleTplClick}
        />;
    }, [
        curTpls,
        isAllowShowTemplate,
        showDefaultTemplate,
        setShowTemplate,
        setIsAllowShowTemplate,
        handleTplClick,
    ]);

    const TemplateShow = !showTemplate || (!isAllowShowTemplate && !showTemplate)
        ? null : renderTemplate;


    useEffect(() => {
        try {
            const config = getMorphoService(serviceNames.IConfigService);
            if (config) {
                const preValue = config.state.editorConfig.getValue();
                config.state.editorConfig.next({
                    ...preValue,
                    renderBottomSlot: TemplateShow,
                });
            }
        } catch (err) {
            console.error(err);
        }
    }, [TemplateShow, isAllowShowTemplate, renderTemplate, showTemplate]);

    useEffect(() => {
        try {
            const config = getMorphoService(serviceNames.IConfigService);
            if (config && !(window as any).isSdkPage) {
                const preValue = config.state.commentConfig.getValue();
                if (isRightCommentFollow && !preValue.isQuickFollowComment) {
                    config.state.commentConfig.next({
                        ...preValue,
                        isQuickFollowComment: true,
                    });
                }
            }
        } catch (err) {
            console.error(err);
        }
    }, [isRightCommentFollow]);

    useEffect(() => {
        try {
            const config = getMorphoService(serviceNames.IConfigService);
            if (config) {
                const preValue = config.state.editorConfig.getValue();
                if (isHorizontalDragGray && !preValue.horizontalDrag) {
                    config.state.editorConfig.next({
                        ...preValue,
                        horizontalDrag: true,
                    });
                }
            }
        } catch (err) {
            console.error(err);
        }
    }, [isHorizontalDragGray]);

    const saveCustomVersion = (name: string) => {
        return new Promise(async (resolve, reject) => {
            const ksServer = await sdk.getKsServer(repository);
            ksServer
                .saveAsHistoryVersion(repository.repositoryGuid, docGuid, name)
                .then(result => {
                    if (result) {
                        ksServer.renameHistoryVersion(docGuid, result.versionId, name);
                        // 同时标记一个历史版本
                        return createDocEdition(result.versionId, docGuid, sdk.user?.userGuid as string);
                    }
                })
                .then(result => {
                    if (result) {
                        kuJSSDKEventBus.emit(NEW_DOC_VERSION, {
                            spaceGuid: repository.spaceGuid,
                            groupGuid: repository.groupGuid,
                            repositoryGuid: repository.repositoryGuid,
                            docGuid,
                            name,
                            versionId: result.versionId,
                            editionId: result.editionId,
                        });
                    }
                    resolve(result);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    };

    const onlineTodoConfig = useOnlineTodoConfig();
    const todoConfig = useTodoConfig();
    const transclusionConfig = useTransclusionConfig(docGuid);
    const aigcConfig = useAigcConfig(isKuShareMode);

    const render2EmbedContainer = useRender2EmbedContainerWrapper(docGuid);
    const renderEmbedInline = useRenderEmbedInlineWrapper(editorMode, hasEditPermission);

    const getPluginOptionsProxy = kuPiper.runProxy(kuPiper.proxyNameMap.editorPluginOptionsProxy, () => {
        const repo = store.getCurRepository();
        // 如果是部门公告专用知识库，隐藏阅读统计插件
        const showReadStatistics = repo?.sourceType !== RepositorySourceType.notice;
        // 评分插件按知识库的repositoryGuid前端配置小流量名单
        const scorePluginWhiteList = process.env.REACT_APP_SCORE_PLUGIN_WHITE_LIST
            ? process.env.REACT_APP_SCORE_PLUGIN_WHITE_LIST.split(',') : [];
        return {
            toolbar: {
                leftInsertButton: true,
                showButtonPositionChangeGuidance: true,
                insertLayoutGroupV2: true, // 基础布局模板使用路径前置
                insertMenuV2: true, // 编辑器插入菜单优化
                visionV2: true, // 编辑器工具栏优化
            },
            offlineMode: true,
            localBackup: true,
            placeholder: '输入“/”快捷插入',
            editorTitle: {
                // 原本在演示模式也需要展示编辑器标题，但由于编辑器演示模式定位需求影响，将演示模式下标题展示交给编辑器额外处理
                show: mode === EDITOR_MODE.history,
                // 偶现title结点丢失，需知识库把独立保存的文档大标题文本通过配置项传给编辑器
                separateTitleText: docTitle,
            },
            editorConfig: {
                getScrollContainer: () => {
                    return getScrollContainerRef.current();
                },
                showWordCountSelectionMenu: false, // 文档字数小流量下线
                onWordCountSelectionMenuClick(fragment: Node[], plainText: string) {
                    const wordNum = ref.current?.getWordCountBySDK(plainText);
                    store.setShowDocStatDialog(true, wordNum);
                    feLogger(selectionWordCount());
                },
                getDocumentTitle: () => {
                    return document.getElementById('documentTitleDiv')?.innerText || '';
                },
                changeTitle: async (title: string) => {
                    if (!title) {
                        return;
                    }

                    try {
                        const ksServer = await sdk.getKsServer();
                        await ksServer.renameDocument(docGuid, title);
                    } catch (e) {
                        console.error(e);
                    }
                },
                onGoTopVisible: isShowReturnTop,
                renderBottomSlot: TemplateShow,
                showNewDrag: true, // 拖拽菜单优化
                showTextDecorationMenu: true, // 划选菜单优化小流量下线
                onWordCountUpdate(wordCountInfo: {
                    // 全文字数
                    totalWordCount: number;
                    // 选中字数，当没有选区时，此值不提供，只要提供此值就表示有选区存在，即使字数为 0 也要展示
                    selectedWordCount?: number;
                }) {
                    store.setDocWordNum(wordCountInfo);
                },
                // 新版本开关，需要通过小流量控制。默认为 false
                showNewDragMenu: true, // 行前菜单优化
                showInsertMenuGuide: true, // 斜杠唤起词
                wordCountNewVersion: true, // 文档字数小流量下线
                horizontalDrag: !!isHorizontalDragGray,
                // enableCardHeadingNav 迁移到小流量自动化，稳定后删掉
                // enableCardHeadingNav: !!isNavCardHead,
                // 保存自定义版本接口
                saveCustomVersion: (name: string) => {
                    const returnPromise = saveCustomVersion(name);
                    return returnPromise;
                },
                showTableSelectionMenu: !!isShowTableSelectionMenu,
                // 处理跳转方法
                transformHyperlink: transformHyperlink,
            },
            user: {
                getUsersDetail: (uidList: string[]) => {
                    return new Promise((resolve) => {
                        resolve(renderUpdateList(uidList));
                    });
                },
            },
            userOperation: {
                copyForbidden: docForbidCopy,
                printForbidden: docForbidPrint,
            },
            image: {
                ...imageConfig,
            },
            table: {
                inheritInsertStyle: true, // 表格居中+中间插入行或列
                showPerformanceTips: true, // 大表格是否开启性能提示
                limitMaxCells: true, // 大表格是否开启性能提示
                floatingMenu: true, // 增加表格元素悬浮菜单
                responsiveWidth: true, // 阅读态表格自适应页面宽度
            },
            tableOfContents: {
                // 文档目录卡
                showInserts: !!isDocCatalogCard,
            },
            layout: {
                enable: true, // true 开启、false 关闭。
                layoutBlockEnable: true, // 布局块入口小流量下线
                enableGuide: !isKuShareMode,
            },
            attachment: {
                showDownloadButton: () => true,
                validateDownload,
                convertPDF2Word: showConvertWordEntry ? convertPDF2WordFn : undefined,
                editableFileType: ['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'],
            },
            hyperLink: hyperLinkConfig,
            mention: mentionOptions,
            heading: {
                // 是否允许标题折叠
                fold: true,
                // onNavigationClick(uuid: string) {
                //     window.location.hash = 'anchor-' + uuid;
                // },
                showSplitCardShortcut: true, // 更便捷的拆卡能力
            },
            todolist: todoConfig,
            onlineTodoList: onlineTodoConfig,
            highlight: highlightConfig,
            seperateTitle: {
                focusToTitle,
            },
            comment: {
                shareAndCopy: commentShareAndCopy,
                validateDeleteReply: () => {
                    return !!isCurDocPageAdmin();
                },
                // 评论@人创建群聊
                ...commentOptions,
                ...commentChatOptions,
                defaultCommentFollowState: commentDefaultChecked,
                followDocComment: () => {onMentionSwitchValueChange(true, 'comment');},
                cancelFollowComment: () => {onMentionSwitchValueChange(false, 'comment');},
                isQuickFollowComment: isRightCommentFollow,
                getSlotComponent: (slotId: any, {isEdit, commentId, createGroup}: {isEdit: boolean, commentId: string, createGroup: boolean}) => {
                    return <CommentNoticeInfo slotId={slotId} commentId={commentId} isEdit={isEdit} createGroup={createGroup} />;
                },
                placeholder: '输入评论，@提及他人',
                replyPlaceholder: '输入评论，@提及他人',
            },
            statistics: statisticsOptions,
            diagram: {
                showDownloadButton: () => true,
                enable: true,
                loadAllDiagramsOnLoad: getDiagramLoadAll(),
                canDoubleClickToEdit: !!isFlowChartInGray,
            },
            mindmap: {
                showDownloadButton: () => true,
                enable: true,
                loadAllMindmapsOnLoad: getMindMapLoadAll(),
                canDoubleClickToEdit: !!isFlowChartInGray,
            },
            transclusion: transclusionConfig,
            ai: aigcConfig,
            embed: {
                // DuChat暂时下线，屏蔽配置代码
                // aigc: isOpenAigc ? {
                //     origin: aigcUrl,
                // } : false,
                embed: true,
                aigc: false,
                codePen: true,
                figma: true,
                agent: true,
                datasheetDoc: true,
                score: scorePluginWhiteList.includes(repository?.repositoryGuid) ? {
                    origin: process.env.REACT_APP_SCORE_PLUGIN_ORIGIN || '',
                } : false,
                dataSheet: dataSheetConfig,
                load: (element: any) => {
                    const embedType: EmbedTypes = element?.embedType;

                    // 数据表链接识别，使用 iframe 渲染，需要上报页面打开 PV
                    if (embedType === 'datasheetDoc') {
                        // 打开页面埋点上报
                        feLogger(openPageUrl({
                            pageId: docGuid,
                            repoId: repository?.repositoryGuid,
                            groupId: repository?.groupGuid,
                            docType: LOG_DOC_TYPE.datasheet,
                            user_type: curDocument?.docRoleName || '',
                            open_type: 'link-recognition',
                        }));
                    }
                },
                subDocList: subDocListConfig,
                // 接入TDA小流量下线
                flowIframe: true,
                render2EmbedContainer,
            },
            embedInline: {
                renderEmbedInline,
            },
            slide: {
                onChangeSlide: slideConfig.onChangeSlide,
                onChangeTheme: slideConfig.onChangeTheme,
                onChangeSlideCover: slideConfig.onChangeSlideCover,
                // 卡片视图拆分卡片的引导，全量下线，相关代码后续可清理
                showSlideButtonGuidance: false,
                enableAddNewSlide: true, // 新媒介sp1小流量
                enableAISlide: true, // 智能创作-生成卡片
                enableOptimizeSlide: true, // 智能创作-优化卡片
                enableAISlideMenu: !!isCardViewSP3Gray,
                enableSlideMenuInner: true, // 卡片级操作菜单位置改造
                enableAIMarkKeyPoint: !!isCardViewMarkKeyPointGray,
                enableCardBlockRef,
                disableCardCopyAndShare,
                // getCardMenu: isCardLikeGray ? renderCardLike : undefined,
                showNewSlideMenu: true, // 卡片级菜单优化
                showCardAuthors: showCardAuthors,
                enableQuickInsert: !!templateRequestDone, // 默认 优化空行的输入引导&空白卡片推荐'分栏和模板
                singleCardSizeAdaptation: !isHistoryMode, // 单卡片自适应全屏,历史模式不开启
                renderCardMenus: slideConfig.renderCardMenus,
                renderCardGapMenus: slideConfig.renderCardGapMenus,
            },
            material: {
                enable: materialConfig.enable,
                addMaterial: materialConfig.addMaterial,
                canAddMaterial: materialConfig.canAddMaterial,
                openMaterialPanel: () => {
                    openPanel({tab: SideTabKey.Material, isExternalNotComment: true});
                    eventBus.emit(CLICK_ADD_MATERIAL);
                },
                openMaterialPanel627: () => {
                    openPanel({tab: SideTabKey.Material, isExternalNotComment: true});
                    eventBus.emit(CLICK_ADD_MATERIAL);
                },
                usePlaceholder: true, // 插入模板库使用预置文案
                openMaterialPanel0711: () => {
                    openPanel({tab: SideTabKey.Material, isExternalNotComment: true});
                    eventBus.emit(CLICK_ADD_MATERIAL);
                },
                onDragInsert: (res: any) => {onDragInsert(res);},
            },
            cover: {
                getUploadRecords: coverConfig.getUploadRecords,
                upload: coverConfig.upload,
                save: coverConfig.save,
                onRemoveCover: coverConfig.onRemoveCover,
            },
            presentation: {
                enableNavigation: true, // 演示模式大纲小流量下线
            },
            linkTransform: linkTransformOptions,
        };
    });

    const slot = useMemo(() => {
        const showTitleArea = isShowCurrentView(VIEW_BLOCK.titleArea);
        return {
            top: showTitleArea ? (
                <EditorBanner
                    mode={mode}
                    docGuid={docGuid}
                    repository={repository}
                    updateDoTitle={updateDoTitle}
                    hasEditPermission={hasEditPermission}
                    isWideScreenMode={isWideScreenMode}
                    isNew={isNew}
                    curDocument={curDocument}
                    isCardView={isCardView}
                    titleNode={titleNode}
                    handleTplClick={handleTplClick}
                />
            ) : null,
            bottom: !isNew && (
                <EditorChildren
                    mode={mode}
                    docGuid={docGuid}
                    creatorGuid={curDocument?.userGuid || ''}
                    creatorName={curDocument?.nickname || ''}
                    repository={repository}
                    isCardView={isCardView}
                />
            ),
        };
    }, [
        docGuid,
        hasEditPermission,
        isNew,
        isWideScreenMode,
        mode,
        repository,
        curDocument,
        isCardView,
        updateDoTitle,
        titleNode,
        handleTplClick,
    ]);

    const getEditorStateProxy = kuPiper.runProxy(kuPiper.proxyNameMap.editorStateProxy, () => {
        return {
            mode: editorMode,
            // history模式下，打开自定义版本Tab，默认打开历史记录Tab
            historyTab: store.getData(store.KEYS.HISTORY_MODE_TAB_VALUE) || HistoryModeTabValue.History,
            env: isKuShareMode ? 'kushare' : 'knowledge',
            // TODO: 读写合一小流量，全量后可删除
            interimMode: rwMode,
        };
    });

    const getCommonOptionsProxy = kuPiper.runProxy(kuPiper.proxyNameMap.editorCommonOptionsProxy, () => {
        return {
            appId: DEFAULT_APP_ID,
            appToken: accessToken!,
            permission: hasEditPermission ? 'write' : 'read',
            docOption: {
                docId: docGuid,
            },
            userOption: {
                uid: sdk.as.user?.userGuid || '',
                rlId: sdk.as.user?.rlId,
                name: nickname || '',
                avatar: concatImgSrc(userGuid),
                department: department || '',
                email: email || '',
                uuapId: sdk.as.user!.avatar || '',
            },
            urlOption: {
                entrypoint: rteServer,
                webofficeURL: WEB_OFFICE_URL,
                wsConnectOption: { // Ku享状态下减少重试delay，加快重试的频率
                    maxReconnectionDelay: isKuShareMode ? 3000 : 8000,
                    minReconnectionDelay: 1000 + Math.random() * 1000,
                    reconnectionDelayGrowFactor: 1.1, // how fast the reconnection delay grows
                    connectionTimeout: 3000,
                },
                wsBaseUrl: getRTEWebsocketUrl(), // ws地址
                wsBackupURL: getRTEBackUpUrl(), // ws备用地址，用于连续重连失败后自动更换
                wsRetryCount: 5, // 重连n次连续失败就去判断内网，内网不通就换备用ws地址，备用地址n次依然失败onNotify中就会给失败通知
            },
        };
    });

    const getCustomOptionsProxy = kuPiper.runProxy(kuPiper.proxyNameMap.editorCustomOptionsProxy, () => {
        return {
            share: shareToRuLiu,
            Toast: toast,
            kuShare: kuShareParams ? {kuShareToken: kuShareParams.token} : undefined,
            ksRequest: async (options: WizRequestOptions) => {
                try {
                    const ksServer = await sdk.getKsServer();
                    return ksServer.request({
                        wikiAccessToken: ksServer.wikiAccessToken,
                        ...options,
                    });
                } catch (e) {
                    console.error(e);
                }
            },
            asRequest: async (options: WizRequestOptions) => {
                try {
                    return sdk.as.request({
                        wikiToken: sdk.user?.token,
                        ...options,
                    });
                } catch (e) {
                    console.error(e);
                }
            },
        };
    });

    // 编辑器小流量配置 - 新小流量使用自动化接入
    // const {config} = useEditorSmallFlows();

    const getEditorContent = () => {
        const isSameDoc = (docGuidFromTokenData === docGuid);
        return (
            (accessToken && isSameDoc) && (
                <DocErrorBoundary>
                    <Profiler id={PROFILER_KEY.realtimeEditor} onRender={perfLogger.compRender.onRender}>
                        <RealtimeEditor
                            ref={ref}
                            editorState={getEditorStateProxy()}
                            onNotify={handleRteNotifyProxy}
                            commonOptions={getCommonOptionsProxy()}
                            editorOptions={getEditorOptionsProxy()}
                            pluginOptions={getPluginOptionsProxy()}
                            customOptions={getCustomOptionsProxy()}
                            slot={slot}
                            plugins={isExternalRepo ? {} : morphoPlugins}
                            // flowConfig={config}
                        />
                    </Profiler>
                </DocErrorBoundary>
            )
        );
    };

    useEffect(() => {
        let kuStatusMode: IMode = mode;
        if (showFullScreen) {
            kuStatusMode = 'presentation';
        }

        // 如果开启了快速命令，则屏蔽浏览器超级助理插件快捷指令
        if (quickCmdEnable) {
            kuStatusMode = EDITOR_MODE.edit;
        }
        updateKuStatusMode(kuStatusMode);
        return () => {
            updateKuStatusMode(null);
        };
    }, [mode, quickCmdEnable, showFullScreen]);

    return (
        <div
            style={{
                height: '100%',
            }}
            id={'doc-editor'}
            className={classNames(
                styles.editorWrapper,
                isSafari && styles.safari,
                isPreviewMode && styles.preview,
                isEditMode && styles.edit,
                showFullScreen && styles.full,
                showIframeMask && styles.mask,
                demoMode && demoModeType === DEMO_MODE_TYPE.page && styles.demo,
                styles.editorWrapperScrollBar,
                !showNormalWidth && styles.minWidthWithOnlyContent
            )}
            onClick={nextPaging}
        >
            {getEditorContent()}
            {renderDemoModeLayoutNode()}
            {/* 202306迭代策略更新：内容清空后模板需要重新展示，为避免出现反复请求模板接口，以及引起不必要的外层组建渲染，将展示判断条件挪到模板组件中 */}
            {/* 202401迭代更新：由于封面需求影响，模板需要移到空文档 AI 模板下方维护 */}
            {/* <TemplateArea
                className={classNames(
                    styles.templateWrapper,
                    isWideScreenMode && styles.wide,
                    isKuShareMode && styles.kuShare
                )}
                repository={repository}
                onClick={handleTplClick}
                isNew={isNew}
            /> */}
            {/* 划线评论@人创建群聊弹窗 */}
            <CommentCreateChatModal />
            {/* 返回文档顶部按钮 不能出现在sdk页面 会导致页面崩溃白屏 */}
            {
                !(window as any).isSdkPage && ReturnTopNode && <ReturnTopNode />
            }
        </div>
    );
}));

export default store.connect([
    store.KEYS.CUR_DOCUMENT_TOKEN,
    store.KEYS.IS_WIDE_SCREEN_MODE,
    store.KEYS.OPEN_AIGC_INFO,
    store.KEYS.IS_OPEN_AIGC,
    store.KEYS.KU_SHARE_PARAMS,
    store.KEYS.IS_CARD_VIEW,
    store.KEYS.SHOW_SLIDE,
    store.KEYS.QUICK_CMD_ENABLE,
    store.KEYS.IS_DOC_EMPTY_WITH_SPACE,
])(Editor);
